<template>
    <div>
        <div>
            <h1>{{ name }}</h1>
        </div>

        <luzmo-embed-dashboard
            ref="dashboardInstance"
            :dashboardId="$route.params.id"
            :switchScreenModeOnResize="true"
            :authKey="token.key"
            :authToken="token.token"
        />
    </div>
</template>

<script>
import ReportsApi from 'api/reports/reports';

export default {
    props: {
        title: {
            type: String,
            required: false,
            default: '',
        },
        cumulAuth: {
            type: Object,
            required: false,
            default: () => {},
        },
    },
    data() {
        return {
            token: this.cumulAuth ? this.cumulAuth : false,
            name: this.title,
        };
    },
    created() {
        if (!this.token) {
            this.getReports();
        }
    },
    methods: {
        getReports() {
            ReportsApi.getReports()
                .then((response) => {
                    this.name = response.data.data.find(
                        (report) => report.dashboard_id == this.$route.params.id,
                    ).name;
                    if (
                        response.data.aggregations.cumulio &&
                        response.data.aggregations.cumulio.key
                    ) {
                        this.token = response.data.aggregations.cumulio;
                    }
                })
                .catch(() => {
                    Push.error(this.$l10n.__('Problème lors de la récupération des données'));
                });
        },
    },
};
</script>
